import React from 'react';

// Rich peer-percentile bar (p25→p90 range, peer-median tick, your marker),
// mirroring the Capability Health (PE) benchmark visual. Reused on the
// Behavior (ROE) and Learning (LEI) overviews for a consistent read.
export default function PeerBenchmarkBar({ yourValue, bench, testId }) {
  if (!bench) return null;
  const clamp = (v) => Math.max(2, Math.min(98, v || 0));
  const you = Math.round(yourValue || 0);
  const p25 = bench.p25 ?? bench.peer_median;
  const p90 = bench.p90 ?? bench.peer_median;
  const median = bench.peer_median || 0;
  return (
    <div className="mt-4" data-testid={testId}>
      <div className="relative h-2 rounded-full bg-[#0b1220] ring-1 ring-[#22304d]">
        <div className="absolute inset-y-0 rounded-full bg-cyan-500/25"
          style={{ left: `${clamp(p25)}%`, right: `${100 - clamp(p90)}%` }} />
        <div className="absolute top-1/2 -translate-y-1/2 w-0.5 h-3.5 bg-slate-400"
          style={{ left: `${clamp(median)}%` }} title={`Peer median ${Math.round(median)}`} />
        <div className="absolute top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-[#44b6d2] ring-2 ring-[#0b1220]"
          style={{ left: `calc(${clamp(you)}% - 6px)` }} title={`You ${you}`}
          data-testid={testId ? `${testId}-marker` : undefined} />
      </div>
      <div className="flex justify-between text-[9px] text-slate-500 mt-1.5">
        <span>You {you}</span>
        <span>Median {Math.round(median)}</span>
      </div>
      {bench.sample_size != null && (
        <p className="mt-2 text-[10px] text-slate-500">n≈{bench.sample_size} orgs</p>
      )}
    </div>
  );
}
